import React from "react";
import Icon from "../../Icon";
import range from "lodash/range";
import classNames from "classnames";
const Pager = ({ srLabel, pageIndex, pageCount, onChangePage }) => {
    return (<div className="pagination">
			<h4 className="u-isVisuallyHidden">{srLabel} Pagination</h4>
			<h5 className="u-isVisuallyHidden">{srLabel} Pagination Navigation</h5>
			<button type="button" className={`pagination-nav pagination-nav_prev ${pageIndex === 0 ? "pagination-nav_isDisabled" : ""}`} disabled={pageIndex === 0} onClick={() => onChangePage(pageIndex - 1)} aria-label="Previous">
				<span className="u-isVisuallyHidden">Previous</span>
				<Icon icon="arrowLeft"/>
			</button>
			<button type="button" className={(`pagination-nav pagination-nav_next ${pageIndex === pageCount - 1 ? "pagination-nav_isDisabled" : ""}`)} disabled={pageIndex === pageCount - 1} onClick={() => onChangePage(pageIndex + 1)} aria-label="Next">
				<span className="u-isVisuallyHidden">Next</span>
				<Icon icon="arrowRight"/>
			</button>
			<h5 className="u-isVisuallyHidden">{srLabel} Pagination Numbers</h5>
			<ol className="pagination-list">
				{range(pageCount).map((index) => {
        const disabled = pageIndex === index;
        return (<li className="pagination-list-item" key={index}>
							<button disabled={disabled} type="button" className={classNames("pagination-list-item-number", {
            "pagination-list-item-number_isDisabled": disabled
        })} onClick={() => onChangePage(index)}>
								{index + 1}
							</button>
						</li>);
    })}
			</ol>
		</div>);
};
export default Pager;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/presentational/Pagination/Pager/Pager.tsx